import { styled } from '@vr/ds-react'
import { AsyncPaginate } from 'react-select-async-paginate'

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column'
})

export const Label = styled('label', {
  fontSize: '$tiny',
  fontWeight: '$semiBold',
  lineHeight: '$medium',
  letterSpacing: '$large'
})

export const MultiSelect = styled(AsyncPaginate, {
  '[class*="control"]': {
    display: 'flex',
    cursor: 'pointer',
    minHeight: '42px',
    alignItems: 'center',
    borderRadius: '$borderRadiusSmall',
    border: '1px solid $neutralVeryDark',
    color: '$neutralVeryDark',
    marginTop: '$sm8',
    div: {
      fontSize: '$extraSmall',
      color: '$dark'
    },
    '[class*="loadingIndicator"]': {
      fontSize: '$extraSmall',
      '[class*="LoadingDot"]': {
        width: '$sizes$4',
        height: '$sizes$4',
        marginLeft: '$sizes$4'
      }
    },
    '[class*="indicatorSeparator"]': {
      display: 'none'
    },
    '[class*="multiValue"]': {
      div: {
        backgroundColor: '$primaryDefault'
      },
      '[role=button]': {
        '&:hover': {
          backgroundColor: '$primaryDark'
        }
      }
    }
  },
  '[class*="menu"]': {
    backgroundColor: '$neutralVeryLight',
    color: '$neutralVeryDark',
    borderRadius: '$borderRadiusSmall',
    zIndex: 1000,
    'div > div': {
      alignSelf: 'stretch',
      display: 'flex',
      gap: '$sizes$8',
      alignItems: 'center',
      height: '$sizes$48',
      padding: '$sm16',
      fontSize: '$extraSmall',
      '&:hover, &:active, &:focus': {
        backgroundColor: '$neutralLight'
      }
    }
  }
})
